import { render } from "./dispatch-table.vue?vue&type=template&id=9e892a7e&scoped=true&ts=true"
import script from "./dispatch-table.vue?vue&type=script&lang=ts"
export * from "./dispatch-table.vue?vue&type=script&lang=ts"

import "./dispatch-table.vue?vue&type=style&index=0&id=9e892a7e&lang=stylus&scoped=true"

import exportComponent from "D:\\Front-end-project\\anxin-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e892a7e"]])

export default __exports__